<template>
  <div class="header">
    <div class="cont">
      <router-link class="logo" :to="{ name: 'Home' }">
        <img :src="require('@/assets/img_svg/logo.svg')" alt="svg" />
      </router-link>

      <ul class="menu-box">
        <li class="menu-item">
          {{ $t("h.solution") }}
          <ul class="sub-menu">
            <router-link class="sub-menu-item" :to="{ name: 'Enterprise' }">{{
              $t("h.enterprise")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Retail' }">{{
              $t("h.vn")
            }}</router-link>

            <!-- <router-link
                            class="sub-menu-item"
                            :to="{ name: 'Retail' }"
                            >{{$t("")}}</router-link
                        > -->
          </ul>
        </li>
        <li class="menu-item">
          {{ $t("h.product") }}
          <ul class="sub-menu">
            <router-link
              class="sub-menu-item"
              :to="{ name: 'CloudXpressConnect' }"
              >{{ $t("h.cxc") }}</router-link
            >
            <router-link
              class="sub-menu-item"
              :to="{ name: 'CloudSaasAccerlation' }"
              >{{ $t("h.csa") }}</router-link
            >

            <router-link
              class="sub-menu-item"
              :to="{ name: 'GlobalAppAccess' }"
              >{{ $t("h.gaa") }}</router-link
            >
            <router-link class="sub-menu-item" :to="{ name: 'MobileClient' }">{{
              $t("h.mobility")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Hardware' }">{{
              $t("h.hardware")
            }}</router-link>
          </ul>
        </li>
        <!-- <li class="menu-item">
                    {{ $t("h.customer") }}
                    <ul class="sub-menu">
                        <router-link
                            class="sub-menu-item"
                            :to="{ name: 'CustomerCaseStudy' }"
                            >{{ $t("h.ccs") }}</router-link
                        >

                        <router-link
                            class="sub-menu-item"
                            :to="{ name: 'CustomerCaseStudy' }"
                            >{{ $t("h.Education") }}</router-link
                        >
                        <router-link
                            class="sub-menu-item"
                            :to="{ name: 'CustomerCaseStudy' }"
                            >{{ $t("h.Energy") }}</router-link
                        >
                        <router-link
                            class="sub-menu-item"
                            :to="{ name: 'CustomerCaseStudy' }"
                            >{{ $t("h.Financial") }}</router-link
                        >
                    </ul>
                </li> -->
        <li class="menu-item">
          {{ $t("h.technology") }}
          <ul class="sub-menu">
            <router-link class="sub-menu-item" :to="{ name: 'SDWAN' }"
              >SDWAN</router-link
            >
            <router-link class="sub-menu-item" :to="{ name: 'WhitePager' }">{{
              $t("h.wp")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Download' }">{{
              $t("h.download")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Support' }">{{
              $t("h.Support")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Partner' }">{{
              $t("h.cooperation")
            }}</router-link>
          </ul>
        </li>
        <li class="menu-item">
          {{ $t("h.aboutUs") }}
          <ul class="sub-menu">
            <router-link class="sub-menu-item" :to="{ name: 'Overview' }">{{
              $t("h.overview")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'ExpertTeam' }">{{
              $t("h.et")
            }}</router-link>
            <router-link class="sub-menu-item" :to="{ name: 'Awards' }">{{
              $t("h.awards")
            }}</router-link>

            <router-link class="sub-menu-item" :to="{ name: 'News' }">{{
              $t("h.news")
            }}</router-link>
          </ul>
        </li>
      </ul>
      <div class="other">
        <!-- <span class="login">登陆</span> -->
        <span class="lang" @click="lang">{{ $t("h.lang") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  methods: {
    lang() {
      if (this.$i18n.locale === "zh_CN") {
        this.$i18n.locale = "en_US";
        localStorage.setItem("lang", "en_US");
        this.$bus.$emit("lang", "en_US");
      } else {
        this.$i18n.locale = "zh_CN";
        localStorage.setItem("lang", "zh_CN");
        this.$bus.$emit("lang", "zh_CN");
      }
      this.getTitle();
    },
    getTitle() {
      const title = document.getElementsByTagName("title");
      console.log(title);
      title[0].innerHTML =
        !localStorage.getItem("lang") ||
        localStorage.getItem("lang") === "zh_CN"
          ? "睿云网络"
          : "OceanBlue Cloud";
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.04);
  background-color: #fff;
  z-index: 999999;
}
.cont {
  width: 1200px;
  /* background-color: #f66; */
  height: 100%;
  margin: auto;
  display: flex;
  padding: 0 10px;
  box-sizing: border-box;
}
.logo {
  flex-basis: 200px;
  height: 24px;
  margin-top: 18px;
}
.home-logo {
  width: 200px;
  height: 24px;
}
.menu-box {
  display: flex;
  padding: 0;
  margin: 0;
  margin-left: 80px;
  font-size: 14px;
}
.menu-item {
  color: #333333;
  width: 100px;
  margin-right: 20px;
  line-height: 60px;
  text-align: center;
  position: relative;
  /* font-weight: bold; */
  cursor: pointer;
  transition: all 0.3s ease;
}
.menu-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
  color: #00a3d1;
}
.menu-item:hover .sub-menu {
  display: block;
}
.sub-menu {
  position: absolute;
  top: 60px;
  left: 0;
  margin: 0;
  padding: 0;
  width: 200px;
  text-align: left;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 1;
  display: none;
  box-shadow: 0 2px 6px -4px #909399;
}
.sub-menu-item {
  display: block;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  color: rgba(0, 0, 0, 1);
  padding-left: 10px;
  transition: all 0.3s ease;
}
.sub-menu-item:hover {
  color: #fff;
  background: #00a3d1;
}
.other {
  margin-left: 52px;
  margin-top: 23px;
}
.login {
  padding-right: 20px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
.login:hover {
  color: rgba(0, 0, 0, 1);
}
.login::before {
  content: "";
  position: absolute;
  background-color: #000;
  width: 1px;
  transform: scale(0.5);
  height: 20px;
  right: 0;
  top: 0;
}
.lang {
  padding-left: 20px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  position: relative;
}
.lang:hover {
  color: rgba(0, 0, 0, 1);
}
/* .lang::before {
    content: "";
    position: absolute;
    background-color: #000;
    width: 1px;
    transform: scale(0.5);
    height: 20px;
    left: 0;
    top: 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/Header.vue